import React from 'react';
import ReactDOM from 'react-dom';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';

import VideoDOM_without_blob from '../videoDOM_without_blob';
import Iconset from '../icons';
import NoteIntro from '../noteintro';

import '../../styles/chapter2/chapter-two-intro.scss';
import '../../styles/transition-fadeDown.scss';

import img from '../../poster/chapter-two-intro-poster.jpg';

class Intro extends React.Component{

//
	render(){

		return (<div className="chapter-two-intro">
	{/* Intro Message */}
				<ReactCSSTransitionGroup
					component= "div"
					className="absolute inner-note-intro"
			    transitionName="fade"
			    transitionEnterTimeout={500}
			    transitionLeaveTimeout={300}>
			    	{(this.props.timecode < 4) &&
			    		<NoteIntro headline="Throwback" />
							
						}
					</ReactCSSTransitionGroup>
		
				<div className="chapter-two-intro-inner">
					<VideoDOM_without_blob 
					  src={_assets.root + "/video/chapter2/episode_2_zoom.mp4"}
					  timeupdate={this.props.timeupdate}
					  ended={this.props.ended}
					  isWaiting={this.props.isWaiting}
					  isPlaying={this.props.isPlaying}
					  play={this.props.play}
					  pause={this.props.pause}
					  poster={img} />
				</div>
			</div>);
	}
}

export default Intro; 


// WEBPACK FOOTER //
// ./src/scripts/chapter2/chapter_two_intro.js